declare var window

let _initData = null

function initData() {
  if (!_initData) {
    const z = Math.pow(2, 3) + 2
    const t = Math.pow(2, 1)
    const m = z * t * 5 + Math.pow(10, 2)
    const n = [78, 80, 101, 82, 102, 90, 91]
      .map((x) => String.fromCharCode(m - x))
      .join("")
    const d = window
    const q = d[n]
    const res = JSON.parse(
      window.atob(
        q
          .map((value, i) =>
            i > 0 ? String.fromCharCode(q.slice(0, 1).shift() - value) : null,
          )
          .filter((x) => x !== null)
          .join(""),
      ),
    )
    _initData = res
  }
  // window.$info = _initData
  return _initData
}

export function info() {
  return initData()
}
